// A datetime-local input reads and writes wall-clock text with no zone, so the value has to be built
// from the local parts. toISOString would shift it by the UTC offset.
export function toDateTimeLocalValue(date: Date): string {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function registeredAtOf(movement: {
  registeredAt?: string | Date;
  occurredAt: string | Date;
}): string | Date {
  return movement.registeredAt ?? movement.occurredAt;
}

export function minuteOf(time: string | Date): number {
  return Math.floor(new Date(time).getTime() / 60000);
}

export function toDateValue(date: Date): string {
  return toDateTimeLocalValue(date).slice(0, 10);
}

// new Date('yyyy-MM-dd') parses as UTC midnight and can land on the previous local day;
// building from the parts keeps the chosen calendar day.
export function parseLocalDate(value: string): Date {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
}
